import React, { useState } from "react";
import "../../styles/pages/SettingsPage.css";
import {
  FaTags,
  FaCube,
  FaLayerGroup,
  FaPalette,
  FaPuzzlePiece,
  FaUsersCog,
  FaCreditCard,
  FaClipboardList,
  FaStore,
  FaTruck,
  FaPercentage,
  FaRuler,
  FaUsers,
  FaCogs,
  FaLink,
  FaConnectdevelop,
  FaCode
} from "react-icons/fa";

// Importar ErrorBoundary
import ErrorBoundary from "../../components/common/ErrorBoundary";

// Importar componentes de configuración
import SkuCategoriesManager from "../../components/admin/SkuCategoriesManager";
import SkuMainsManager from "../../components/admin/SkuMainsManager";
import MaterialsManager from "../../components/admin/MaterialsManager";
import ColorsManager from "../../components/admin/ColorsManager";
import AccessoriesManager from "../../components/admin/AccessoriesManager";
import SkuMaterialRefsManager from "../../components/admin/SkuMaterialRefsManager";
import SkuAccessoryRefsManager from "../../components/admin/SkuAccessoryRefsManager";
import MaterialColorsManager from "../../components/admin/MaterialColorsManager";
import RolesManager from "../../components/admin/RolesManager";
import PaymentMethodsManager from "../../components/admin/PaymentMethodsManager";
import OrderStatusManager from "../../components/admin/OrderStatusManager";
import EcommerceTypesManager from "../../components/admin/EcommerceTypesManager";
import DeliveryTypesManager from "../../components/admin/DeliveryTypesManager";
// import SellerCommissionsManager from "../../components/admin/SellerCommissionsManager"; // ELIMINADO: módulo comisiones removido
import SkuMeasurementsManager from "../../components/admin/SkuMeasurementsManager";
import UsersManager from "../../components/admin/UsersManager";
import ClientsManager from "../../components/admin/ClientsManager";
import CompanySettingsManager from "../../components/admin/CompanySettingsManager";
// import DeliveryTimesManager from "../../components/admin/DeliveryTimesManager"; // ELIMINADO: funcionalidad fusionada en ecommerce_type
import { FaBuilding } from "react-icons/fa";
import { useEffect } from "react";

function SettingsPage() {
  // Recuperar la última pestaña activa de localStorage, o 'categories' por defecto
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem('settings_active_tab') || 'categories';
  });

  // Guardar la pestaña activa cuando cambie
  useEffect(() => {
    localStorage.setItem('settings_active_tab', activeTab);
  }, [activeTab]);

  const tabs = [
    { id: 'company', label: 'Datos de Empresa', icon: FaBuilding },
    { id: 'categories', label: 'Categorías SKU', icon: FaTags },
    { id: 'skus', label: 'SKUs Principales', icon: FaCube },
    { id: 'materials', label: 'Materiales', icon: FaLayerGroup },
    { id: 'colors', label: 'Colores', icon: FaPalette },
    { id: 'accessories', label: 'Accesorios', icon: FaPuzzlePiece },
    { id: 'clients', label: 'Clientes', icon: FaUsers },
    { id: 'sku-material-refs', label: 'Referencias SKU-Material', icon: FaLink },
    { id: 'sku-accessory-refs', label: 'Referencias SKU-Accesorio', icon: FaConnectdevelop },
    { id: 'material-colors', label: 'Códigos Material-Color', icon: FaCode },
    { id: 'roles', label: 'Roles', icon: FaUsersCog },
    { id: 'payment-methods', label: 'Métodos de Pago', icon: FaCreditCard },
    { id: 'order-status', label: 'Estados de Orden', icon: FaClipboardList },
    { id: 'ecommerce-types', label: 'Tipos de Ecommerce', icon: FaStore },
    { id: 'delivery-types', label: 'Tipos de Entrega', icon: FaTruck },
    // { id: 'delivery-times', label: 'Tiempos de Entrega', icon: FaClock }, // ELIMINADO: fusionado en ecommerce_type
    // { id: 'seller-commissions', label: 'Comisiones', icon: FaPercentage }, // ELIMINADO: módulo comisiones removido
    { id: 'sku-measurements', label: 'Medidas SKU', icon: FaRuler },
    { id: 'users', label: 'Usuarios', icon: FaCogs }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'company':
        return <CompanySettingsManager />;
      case 'categories':
        return <SkuCategoriesManager />;
      case 'skus':
        return <SkuMainsManager />;
      case 'materials':
        return <MaterialsManager />;
      case 'colors':
        return <ColorsManager />;
      case 'accessories':
        return <AccessoriesManager />;
      case 'clients':
        return <ClientsManager />;
      case 'sku-material-refs':
        return <SkuMaterialRefsManager />;
      case 'sku-accessory-refs':
        return <SkuAccessoryRefsManager />;
      case 'material-colors':
        return <MaterialColorsManager />;
      case 'roles':
        return <RolesManager />;
      case 'payment-methods':
        return <PaymentMethodsManager />;
      case 'order-status':
        return <OrderStatusManager />;
      case 'ecommerce-types':
        return <EcommerceTypesManager />;
      case 'delivery-types':
        return <DeliveryTypesManager />;
      // case 'delivery-times': // ELIMINADO: fusionado en ecommerce_type
      //   return <DeliveryTimesManager />;
      // case 'seller-commissions': // ELIMINADO: módulo comisiones removido
      //   return <SellerCommissionsManager />;
      case 'sku-measurements':
        return <SkuMeasurementsManager />;
      case 'users':
        return <UsersManager />;
      default:
        return <CompanySettingsManager />;
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <h2><FaCogs /> Configuración de Productos</h2>
        <p className="text-muted">Gestiona categorías, SKUs, materiales, colores y accesorios del sistema</p>
      </div>

      {/* Navegación por pestañas */}
      <div className="settings-tabs">
        <ul className="nav nav-pills nav-fill mb-4" role="tablist">
          {tabs.map(tab => {
            const IconComponent = tab.icon;
            return (
              <li className="nav-item" key={tab.id}>
                <button
                  className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(tab.id)}
                  type="button"
                >
                  <IconComponent />
                  <span className="tab-label ms-2">{tab.label}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>

      {/* Contenido de la pestaña activa */}
      <div className="settings-content">
        <ErrorBoundary key={activeTab}>
          {renderTabContent()}
        </ErrorBoundary>
      </div>
    </div>
  );
}

export default SettingsPage;
